import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d584d2be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OSelecionarMembrosProjeto__Perfil" }
const _hoisted_2 = { class: "OSelecionarMembrosProjeto__NomeEmail" }
const _hoisted_3 = { class: "quebrar-texto-em-uma-linha" }
const _hoisted_4 = { class: "quebrar-texto-em-uma-linha" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Limpar ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Aplicar ")
const _hoisted_7 = { class: "ajustar-textos-longos" }
const _hoisted_8 = { class: "OSelecionarMembrosProjeto__BotoesNovosMembros" }

import { computed, ref, onMounted } from "vue"

  // componentes
  import Avatar from "primevue/avatar"
  import Column from "primevue/column"

  import DataTable, { DataTableFilterMeta } from "primevue/datatable"
  import PButton from "primevue/button"
  import { PageState } from "primevue/paginator"
  import {
    MInput,
    MDropdown,
    AEstadoVazioTabela,
    APaginadorDeTabela,
  } from "@/components/Gerais"

  // composables
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarFiltragem } from "@/composable/UsarFiltragem"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"

  // profissionais
  import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
  import {
    ListarProfissionais,
    ParamsProfissional,
  } from "@/repositorios/profissional/profissional.modelo"


  import Skeleton from "primevue/skeleton"
  import { MembroDoProjeto } from "@/repositorios/projeto/projeto.modelo"
  import { usarBuscarMaisDados } from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import { useI18n } from "vue-i18n"

  interface Props {
    profissionaisSelecionados: ListarProfissionais[]
    profissionaisPreSelecionados: string[]
    destino?: string
  }

  type EmitirModel = {
    (
      event: "update:profissionaisSelecionados",
      profissionaisSelecionados: ListarProfissionais[]
    ): void
    (event: "onFecharTabelaDeAdicaoDeMembros"): void
    (event: "enviarMembrosSelecionados"): void
    (event: "adicionarMembro", membro: MembroDoProjeto): void
    (event: "removerMembro", membro: MembroDoProjeto): string
    (
      event: "update:profissionaisPreSelecionados",
      profissionaisPreSelecionados: string[]
    )
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OSelecionarMembrosProjeto',
  props: {
    profissionaisSelecionados: null,
    profissionaisPreSelecionados: null,
    destino: null
  },
  emits: ["update:profissionaisSelecionados", "onFecharTabelaDeAdicaoDeMembros", "enviarMembrosSelecionados", "adicionarMembro", "removerMembro", "update:profissionaisPreSelecionados"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (
      event: "update:profissionaisSelecionados",
      profissionaisSelecionados: ListarProfissionais[]
    ): void
    (event: "onFecharTabelaDeAdicaoDeMembros"): void
    (event: "enviarMembrosSelecionados"): void
    (event: "adicionarMembro", membro: MembroDoProjeto): void
    (event: "removerMembro", membro: MembroDoProjeto): string
    (
      event: "update:profissionaisPreSelecionados",
      profissionaisPreSelecionados: string[]
    )
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    profissionaisSelecionados: ListarProfissionais[]
    profissionaisPreSelecionados: string[]
    destino?: string
  }

  // framework cores
  
  

  const { t } = useI18n()

  const PRIMEIRA_PAGINA_PADRAO = 0
  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 460px)"

  const profissionalRep = new ProfissionalRepositorio()

  const profissionais = ref<ListarProfissionais[]>([])
  const {
    filtros: filtrosComposable,
    preencherFiltro,
    removerFiltro,
  } = usarFiltragem()

  const { pegarIniciais } = usarFuncoesStrings()
  const { leitor } = usarLeitorDeDados()

  const lerProfissionais = leitor<ListarProfissionais, ParamsProfissional>(
    profissionalRep.listarProfissionaisFrontend,
    {
      ativo: "igual.true",
      tem_usuario_relacionado: "igual.true",
      "ordenar-por": "asc.nome",
    }
  )


  const estaCarregandoMembros = computed(() => {
    return lerProfissionais.resultado.status === "pendente"
  })
  const quantidadeDeMembrosSelecionados = computed(() => {
    if (estaCarregandoMembros.value) {
      return ""
    }
    return String(
      emitirSelecionados.value.length +
      profissionaisPreSelecionados.value.length
    )
  })
  const emitirSelecionados = computed({
    get() {
      return props.profissionaisSelecionados
    },
    set(profissionaisSelecionados: ListarProfissionais[]) {
      emitir("update:profissionaisSelecionados", profissionaisSelecionados)
    },
  })

  const profissionaisPreSelecionados = computed({
    get() {
      return props.profissionaisPreSelecionados
    },
    set(preSelecionados: string[]) {
      emitir(
        "update:profissionaisPreSelecionados",
        preSelecionados
      )
    },
  })

  const obterMembroDeProfissional = (profissional: ListarProfissionais) => {
    return {
      idUsuario: profissional.usuarioRelacionado?.id!,
      codigo: profissional.codigo,
      nome: profissional.nome,
      emailUsuario: profissional.email,
    }
  }
  const onSelecionarLinha = (event): void => {
    emitir("adicionarMembro", obterMembroDeProfissional(event.data))
  }
  const onDesselecionarLinha = (event): void => {
    emitir("removerMembro", obterMembroDeProfissional(event.data))
  }
  const fotoOuIniciais = (foto: string, nome: string): string => {
    return foto || pegarIniciais(nome)
  }

  const listarProfissionais = async (
    pagina: number,
    porPagina = 10
  ): Promise<void> => {
    await lerProfissionais.porPagina(porPagina).pagina(pagina).executar()

    if (lerProfissionais.resultado.status === "sucesso") {
      profissionais.value = lerProfissionais.resultado.dados
      definirItensPreSelecionados()
    }
  }


  const filtrarProfissionais = async (): Promise<void> => {
    lerProfissionais.sobrescreverParametros({
      ...filtrosComposable.value,
    })

    lerProfissionais.primeiraPagina = PRIMEIRA_PAGINA_PADRAO
    await listarProfissionais(lerProfissionais.primeiraPagina)
  }

  const onPaginarProfissionais = async ({
    page,
    rows,
  }: PageState): Promise<void> => {
    await listarProfissionais(page, rows)
  }

  const aplicarFiltros = async (
    dadosDoPreenchimentoDoFiltro: Record<string, any>,
    nomeDaColunaNaAPI: string
  ): Promise<void> => {
    const { matchMode, value } = (
      dadosDoPreenchimentoDoFiltro as DataTableFilterMeta
    ).constraints[0]

    preencherFiltro(nomeDaColunaNaAPI, matchMode, value)

    filtrarProfissionais()
  }

  const limparFiltros = async (nome, filterCallback): Promise<void> => {
    removerFiltro(nome)
    filterCallback()
    filtrarProfissionais()
  }

  const enviarMembrosSelecionados = (): void => {
    emitir("enviarMembrosSelecionados")
  }
  const cancelarAdicaoDeMembros = (): void => {
    emitirSelecionados.value = []
    emitir("onFecharTabelaDeAdicaoDeMembros")
  }

  const definirItensPreSelecionados = (): void => {
    const naoTemProjetosPreSelecionados =
      profissionaisPreSelecionados.value.length === 0
    if (naoTemProjetosPreSelecionados) {
      return
    }
    const pegarPreSelecionadosDaPaginaAtual = (): ListarProfissionais[] => {
      return profissionais.value.filter((profissional: ListarProfissionais) => {
        return (
          profissional.usuarioRelacionado &&
          props.profissionaisPreSelecionados.includes(
            profissional.usuarioRelacionado.id!
          )
        )
      })
    }
    const removerRecemSelecionadosDaListaDePreSelecionados = (): string[] => {
      return profissionaisPreSelecionados.value.filter(
        (profissionalPreSelecionado) => {
          return !profissionaisPreSelecionadosEncontrados.some(
              (profissional: ListarProfissionais) => {
                return (
                  profissional.usuarioRelacionado &&
                  profissional.usuarioRelacionado.id ===
                    profissionalPreSelecionado
                )
              }
            )
        }
      )
    }

    const somenteOsSelecionadosQueNaoEstaoPreSelecionados =
      (): ListarProfissionais[] => {
        return emitirSelecionados.value.filter((profissional) => {
          return !profissionaisPreSelecionados.value.some(
            (profissionalPreSelecionado) => {
              return (
                profissional.usuarioRelacionado &&
                profissional.usuarioRelacionado.id ===
                profissionalPreSelecionado
              )
            }
          )
        })
      }

    const profissionaisPreSelecionadosEncontrados =
      pegarPreSelecionadosDaPaginaAtual()

    profissionaisPreSelecionados.value =
      removerRecemSelecionadosDaListaDePreSelecionados()

    emitirSelecionados.value = [
      ...somenteOsSelecionadosQueNaoEstaoPreSelecionados(),
      ...profissionaisPreSelecionadosEncontrados,
    ]
  }

  onMounted(() => {
    listarProfissionais(lerProfissionais.primeiraPagina)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    selection: _unref(emitirSelecionados),
    "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirSelecionados) ? (emitirSelecionados).value = $event : null)),
    onRowSelect: onSelecionarLinha,
    onRowUnselect: onDesselecionarLinha,
    "onUpdate:filters": filtrarProfissionais,
    class: "OSelecionarMembrosProjeto p-datatable-sm",
    "data-key": "codigo",
    "data-testid": "OSelecionarMembrosProjeto",
    loading: _unref(estaCarregandoMembros),
    "meta-key-selection": false,
    "responsive-layout": "scroll",
    rows: _unref(lerProfissionais).itensPorPagina,
    "scroll-height": ALTURA_RELATIVA_DA_TABELA,
    scrollable: "",
    "selection-mode": "multiple",
    "striped-rows": "",
    value: profissionais.value
  }, _createSlots({
    loading: _withCtx(() => [
      _createVNode(_unref(Skeleton), {
        height: "100%",
        width: "100%"
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(APaginadorDeTabela), {
        "ao-paginar": onPaginarProfissionais,
        leitor: _unref(lerProfissionais)
      }, null, 8, ["leitor"]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(PButton), {
          onClick: enviarMembrosSelecionados,
          class: "OSelecionarMembrosProjeto__Adicionar p-button-success",
          "data-testid": "OSelecionarMembrosProjeto__Adicionar",
          label: `${_unref(t)('adicionar')} ${_unref(quantidadeDeMembrosSelecionados)} ${_unref(t)('membros')}`
        }, null, 8, ["label"]),
        _createVNode(_unref(PButton), {
          onClick: cancelarAdicaoDeMembros,
          class: "OSelecionarMembrosProjeto__Cancelar p-button-danger",
          label: _unref(t)('cancelar')
        }, null, 8, ["label"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OSelecionarMembrosProjeto__Column",
        field: "nome",
        header: _unref(t)('profissionais'),
        "show-add-button": false,
        "show-filter-operator": false,
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Avatar), {
              class: "OSelecionarMembrosProjeto__Avatar",
              "data-testid": "OSelecionarMembrosProjeto__Avatar",
              label: fotoOuIniciais(data.foto, data.nome),
              shape: "circle"
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(data.nome), 1),
              _createElementVNode("small", _hoisted_4, _toDisplayString(data.email ? data.email : _unref(t)('emailNaoInformado')), 1)
            ])
          ])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "filtro-nome-do-profissional",
            placeholder: _unref(t)('pesquisarPorNomeDoProfissional'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field, filterCallback }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (limparFiltros(field, filterCallback))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OSelecionarMembrosProjeto__Column",
        field: "codigo",
        header: _unref(t)('codigo'),
        "show-add-button": false,
        "show-filter-operator": false
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(data.codigo), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_unref(MInput), {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            nome: "filtro-codigo",
            placeholder: _unref(t)('pesquisarPorCodigoDoProfissional'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        filterclear: _withCtx(({ field, filterCallback }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (limparFiltros(field, filterCallback))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('limpar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        filterapply: _withCtx(({ filterModel, field }) => [
          _createVNode(_unref(PButton), {
            onClick: ($event: any) => (aplicarFiltros(filterModel, field))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('aplicar')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 2
  }, [
    (!_unref(estaCarregandoMembros))
      ? {
          name: "empty",
          fn: _withCtx(() => [
            _createVNode(_unref(AEstadoVazioTabela))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["selection", "loading", "rows", "value"]))
}
}

})